import {showLogin} from './login';
import loginTemplate from 'text!_login/login.html';
import { initializeI18next, Screen, type AllTranslationKeys } from 'shared/services/TranslatorNext/TranslationService';
import '../../styles/google-button.scss';

function translateLoginDOM(root: Element | Document = document): void {
	const inst = window.i18nextInstance;
	if (!inst) {
		return;
	}

	// Handle nodes with text content + optional attributes
	const nodes = root.querySelectorAll('[vwo-html-translate]');
	nodes.forEach((el) => {
		const key = el.getAttribute('vwo-html-translate') as AllTranslationKeys;
		(el as HTMLElement).innerHTML = inst.t(key);

		const attrList = el.getAttribute('vwo-html-translate-attr');
		if (attrList) {
			attrList.split(',').forEach((attrName) => {
				const customKey = el.getAttribute(`vwo-html-translate-${attrName.trim()}`);
				const attrKey = (customKey || `${key}.${attrName.trim()}`) as AllTranslationKeys;
				(el as HTMLElement).setAttribute(attrName.trim(), inst.t(attrKey));
			});
		}
	});

	// Handle nodes with only attributes (no text content)
	const attrOnlyNodes = root.querySelectorAll('[vwo-html-translate-attr]:not([vwo-html-translate])');
	attrOnlyNodes.forEach((el) => {
		const attrList = el.getAttribute('vwo-html-translate-attr');
		if (!attrList) {
			return;
		}
		attrList.split(',').forEach((attrName) => {
			const customKey = el.getAttribute(`vwo-html-translate-${attrName.trim()}`) as AllTranslationKeys;
			if (customKey) {
				(el as HTMLElement).setAttribute(attrName.trim(), inst.t(customKey));
			}
		});
	});
}

initializeI18next(Screen.LOGIN).then(() => {
	const selector = '.js-login-placeholder';
	const container = document.querySelector(selector);
	if (!container) {
		return;
	}
	container.innerHTML = loginTemplate;
	showLogin();
	translateLoginDOM(container);
});

